import * as React from 'react';
import styled from 'styled-components';
import { DSTypography } from '../../mui';

const StyledIconText = styled(DSTypography).attrs({
    variant: 'body2',
})<{ $withBold?: boolean; $right?: boolean }>`
    display: inline-block;

    ${props =>
        props.$withBold &&
        `
            font-weight: bold;
        `}

    ${props =>
        props.$right &&
        `
            margin-left: auto;
        `}
`;

const StyledPostIconWrapper = styled.span<{ $fontSize: React.CSSProperties['fontSize'] }>`
    display: inline-flex;
    align-items: center;
    vertical-align: middle;

    svg {
        margin-right: 4px;
        font-size: ${props => props.$fontSize};
    }
`;

interface ReportPostIconProps {
    children?: React.ReactNode;
    fontSize?: React.CSSProperties['fontSize'];
    withBold?: boolean;
    right?: boolean;
}

export const ReportPostIcon: React.FC<ReportPostIconProps> = ({
    children,
    fontSize = '1.1rem',
    right,
    withBold = false,
}) => (
    <StyledIconText $right={right} $withBold={withBold}>
        <StyledPostIconWrapper $fontSize={fontSize}>{children}</StyledPostIconWrapper>
    </StyledIconText>
);
ReportPostIcon.displayName = 'ReportPostIcon';
